"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prediction_model_results_viz_1 = require("@tableau/prediction-model-results-viz");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var RootReducer_1 = require("../../app/RootReducer");
var FlowFilterCard_1 = require("../../img/model-results/FlowFilterCard");
var MapperUtils_1 = require("../../util/MapperUtils");
var TestIds_1 = require("../../util/TestIds");
var Index_1 = require("../base/Index");
var NavigationContext_1 = require("../base/NavigationContext");
var ModelResultAlertDetails_1 = require("./common/ModelResultAlertDetails");
var ModelResultImprovePerformance = function () {
    var refs = React.useContext(NavigationContext_1.NavigationContext);
    var setNavigationRef = function (node) {
        refs['MODEL_RESULT_IMPROVE_PERFORMANCE'] = node;
    };
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), alerts = _a.alerts, qualityCheckPass = _a.qualityCheckPass;
    var recommendedAlerts = (0, MapperUtils_1.getRecommendedAlerts)(alerts);
    var acceptedAlerts = (0, MapperUtils_1.getAcceptedAlerts)(alerts);
    var ignoreAlerts = (0, MapperUtils_1.getIgnoredAlerts)(alerts);
    return (React.createElement("div", { ref: setNavigationRef, "data-tb-test-id": TestIds_1.MODEL_RESULT_IMPROVE_PERFORMANCE_TEST_ID },
        React.createElement(Index_1.Card.List, { icon: React.createElement(FlowFilterCard_1.FlowFilterCard, null), title: Localize_1.Messages.modelResultImprovePerformanceTitle(), description: Localize_1.Messages.modelResultImprovePerformanceSubtitle(), expand: true },
            React.createElement(Index_1.Card, null,
                React.createElement(prediction_model_results_viz_1.AlertSummaryComponent, { qualityCheckPass: qualityCheckPass, acceptedRecommendations: acceptedAlerts.length, ignoredRecommendations: ignoreAlerts.length, recommendationsNeedReview: recommendedAlerts.length, hideBorder: true })),
            React.createElement(Index_1.Card, null,
                React.createElement(ModelResultAlertDetails_1.default, null)))));
};
exports.default = ModelResultImprovePerformance;
//# sourceMappingURL=ModelResultImprovePerformance.js.map